import React, { Component } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select/creatable';

import {
	ON_PREM_CRM,
	NXT_CRM,
	DEMO_CRM,
	SPS_CRM,
	DONORPERFECT_CRM,
	OTHER_CRM,
} from 'src/utils/authOrg.constants';
import { requestUpdateAuthOrganization } from 'src/redux/authOrganizations/authOrganization.action';
import theme from 'src/lib/theme';

const crmSelectStyles = {
	indicatorSeparator: base => ({ ...base, display: 'none' }),
	placeholder: base => ({
		...base,
		color: 'rgb(117, 117, 117)',
		fontFamily: 'Arial',
		fontStretch: '100%',
		fontWeight: '400',
		lineHeight: 'normal',
	}),
	control: base => ({
		...base,
		padding: '4px',
		border: 0,
		boxShadow: 0,
		color: theme.colors.riverBed,
		fontSize: '16px',
		background: '#eaf1ff',
		width: '100%',
		height: '44px',
		borderRadius: '4px',
		marginBottom: '15px',
		marginRight: '15px',
		cursor: 'text',
	}),
	option: (base, { isFocused }) => ({
		...base,
		border: 0,
		boxShadow: 0,
		background: isFocused ? theme.colors.lavender : 'white',
		color: isFocused ? theme.colors.cornflower : theme.colors['very-cool-grey'],
		width: '100%',
		borderRadius: '4px',
		marginRight: '15px',
		cursor: 'pointer',
	}),
	input: base => ({ ...base, color: theme.colors.riverBed }),
	singleValue: base => ({ ...base, color: theme.colors.riverBed }),
};

class CRMSelect extends Component {
	state = { crm: null };

	applyToValue = onChange => {
		return option => onChange(option ? option.value : null);
	};

	render() {
		const options = [
			{ value: NXT_CRM, label: "Raiser's Edge NXT" },
			{ value: ON_PREM_CRM, label: "Raiser's Edge 7" },
			{ value: SPS_CRM, label: 'Silent Partner Software' },
			{ value: DONORPERFECT_CRM, label: 'DonorPerfect' },
			...(this.props.isWiselyDemoUser ? [{ value: DEMO_CRM, label: 'Demo' }] : []),
			{ value: OTHER_CRM, label: 'Other' },
		];

		return (
			<Select
				placeholder="CRM"
				styles={crmSelectStyles}
				options={options}
				onChange={this.applyToValue(this.props.onChange)}
			/>
		);
	}
}

export default connect(null, {
	requestUpdateAuthOrganization,
})(CRMSelect);



// WEBPACK FOOTER //
// ./src/ConnectedComponents/Signup/CRMSelect/index.js